import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Legal.scss';

const RemoveAccount = () => {
  return (
    <>
      <Header />
      <div className="legal-container">
        <div className="legal-content">
          <Link to="/" className="back-link">
            <FiArrowLeft />
            <span>Back to Home</span>
          </Link>

          <h1 className="legal-title">Delete Your Invits Account</h1>
          <p className="legal-updated">
            Last Updated:{" "}
            {new Date().toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>

          <div className="legal-section">
            <h2>1. How to Delete Your Account</h2>
            <p>
              You can request account deletion directly from within the Invits app by following these steps:
            </p>
            <ul>
              <li>Open the <strong>Invits</strong> app.</li>
              <li>Go to <strong>Settings → Account Details</strong>.</li>
              <li>Scroll down to the bottom and tap on <strong>More</strong>.</li>
              <li>Press <strong>Delete Account</strong> and confirm your request.</li>
            </ul>
            <p>
              Once confirmed, your account will be <strong>scheduled for deletion</strong>. You’ll receive a confirmation in-app and by email (if available).
            </p>
          </div>

          <div className="legal-section">
            <h2>2. Deletion Timeline</h2>
            <p>
              After submitting your request, your account enters a <strong>60-day grace period</strong>.
              During this period:
            </p>
            <ul>
              <li>Your account and profile become inactive and hidden from other users.</li>
              <li>You can restore your account anytime by logging back in.</li>
              <li>If you do not log in again within 60 days, your account and all associated data will be <strong>permanently deleted within 90 days</strong> of the request.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>3. Data That Will Be Deleted</h2>
            <ul>
              <li>Your account information (name, username, email, and phone).</li>
              <li>Profile details such as bio, profile picture, and preferences.</li>
              <li>All invitations you created, RSVP data, and guest lists.</li>
              <li>Chats, messages, and shared media.</li>
              <li>Community memberships and interactions.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>4. Data That May Be Retained Temporarily</h2>
            <p>
              Some data may be securely retained for up to 90 days for:
            </p>
            <ul>
              <li>Fraud prevention and abuse monitoring.</li>
              <li>Compliance with financial or legal obligations (e.g., payments, tax invoices).</li>
              <li>System backups and audit logs (automatically purged after the retention period).</li>
            </ul>
            <p>
              All retained data is handled in accordance with our{" "}
              <Link to="/privacy-policy">Privacy Policy</Link>.
            </p>
          </div>

          <div className="legal-section">
            <h2>5. Contact for Account Deletion</h2>
            <p>
              If you experience any issues deleting your account from within the app, you can also request deletion via email:
            </p>
            <ul>
              <li>
                📧 Email: <a href="mailto:privacy@invits.co">privacy@invits.co</a>
              </li>
              <li>
                Subject line: <strong>Account Deletion Request</strong>
              </li>
            </ul>
            <p>
              We will verify your identity and process your deletion request within 7 business days of confirmation.
            </p>
          </div>

          <div className="legal-section">
            <h2>6. Developer Information</h2>
            <p>
              <strong>Invits</strong> is a product by <strong>Forte Technologies</strong>.
              For privacy and data deletion inquiries, contact us at:
            </p>
            <ul>
              <li>Email: <a href="mailto:privacy@invits.co">privacy@invits.co</a></li>
              <li>Website: <a href="https://invits.co">https://invits.co</a></li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RemoveAccount;
